<template>
  <div
    class="soha-status-label"
    :style="statusLabelStyle"
  >
    <span>{{ label }}</span>
  </div>
</template>

<script>
import "@/assets/css/components/base/status-label.css";

export default {
  name: "StatusLabel",
  props: {
    color: {
      type: String,
      require: true,
      default: null,
    },
    label: {
      type: String,
      require: true,
      default: null,
    },
  },
  computed: {
    statusLabelStyle: function () {
      return {
        color: `var(--tag-dark-${this.color}-color)`,
        border: `0.037rem solid var(--tag-light-${this.color}-color)`,
        "background-color": `var(--tag-light-${this.color}-color)`,
      };
    },
  },
};
</script>
